module.exports = __webpack_public_path__ + "static/media/mt-ut-img-6.72209933.png";